// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3beDa","subheader":"ReorderModal_subheader__hovBc","listWrap":"ReorderModal_listWrap__2_boe"};